/**
 * @file index.tsx
 *
 * @fileoverview Shows the contact form.
 */

import React, { Component } from 'react';
import { Contact } from '../../components/Contact';
import { GdprConsentProvider } from '~/jobiqo/components/GDPRConsent/hooks/useGdprConsentContext';

export class ContactPage extends Component {
  public render() {
    return (
      <GdprConsentProvider>
        <Contact />
      </GdprConsentProvider>
    );
  }
}

export default ContactPage;
